import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    role: '',
    phone: '',
    identityId: '',
    shortId: '',
    authority: [],
    organizations: [],
    organization: [],
    selectOrganization: [],
    currentPageMatchOrg: [],
    currentPageNotMatchOrg: [],
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.avatar = action.payload.avatar
            state.userName = action.payload.userName
            state.phone = action.payload.phone
            state.identityId = action.payload.identityId
            state.shortId = action.payload.shortId
        },
        setOrganizations: (state, action) => {
            state.organizations = action.payload
        },
        setOrganization: (state, action) => {
            const scopesSet = new Set()
            action.payload.forEach((obj) => {
                obj.scopes.forEach((scope) => {
                    scopesSet.add(scope)
                })
            })
            state.organization = action.payload
            // state.role = 'owner'
            state.authority = Array.from(scopesSet)
        },
        setSelectOrganization: (state, action) => {
            state.selectOrganization = action.payload
        },
        setCurrentPageMatchOrg: (state, action) => {
            state.currentPageMatchOrg = action.payload
        },
        setCurrentPageNotMatchOrg: (state, action) => {
            state.currentPageNotMatchOrg = action.payload
        },
        userLoggedOut: () => initialState,
    },
})

export const selectOrganization = (state, id) => {
    return state.auth.user.organizations.find((org) => org.id === id)
}

export const selectUserEnableFuncs = (state, id) => {
    return (
        state.auth.user.organizations.find((org) => org.id === id)
            ?.enable_funcs || []
    )
}

export const {
    setUser,
    setOrganizations,
    setOrganization,
    setSelectOrganization,
    setCurrentPageMatchOrg,
    setCurrentPageNotMatchOrg,
    userLoggedOut,
} = userSlice.actions

export default userSlice.reducer
